import {
  faEdit,
  faEllipsisH,
  faEye,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import StatusBullet from "../invoices/components/utils/StatusBullet";
import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OffersActions from "../offers/libs/Offers";
import { numberFormatter } from "../libs/numberFormatter";
import {extractPaginationData} from "../libs/pagination";
import {messageShown} from "../store/reducers/message";
import {useDispatch} from "react-redux";

export default function OfferTable({
  id,
  offer_date,
  status,
  setPaginationData,
  uuid,
  setLoading,
  index,
  offer_number,
  offer_lines,
  customer_name,
  paginationData,
  translated_status,
  getPaginatedOffers
}) {
  const [rowNumber, setRowNumber] = useState(1);
  const {t, i18n} = useTranslation();
  const currentLang = i18n.language;
  const dispatch = useDispatch();

  useEffect(() => {
    setRowNumber(
      paginationData?.page * paginationData?.perPage +
        1 -
        paginationData?.perPage
    );
  }, [paginationData]);


  const deleteOffer = (offerId, page = paginationData?.page || 1) => {
    setLoading && setLoading(true);
    OffersActions.deleteOffer(offerId)
      .then((res) => {
        
        setLoading && setLoading(false);
      
        const success = !!(res && (res.success || res.succes));
        getPaginatedOffers(page);
        const messageText =
          res?.message ||
          (success ? t("Offer has been successfully removed") : t("Unable to delete offer"));
        dispatch(
          messageShown({
            show: true,
            message: messageText,
            variant: success ? "success" : "danger",
          })
        );
      })
      
  };

  const offerStatus = status
    .split(" ")
    .map((w) => w[0].toUpperCase() + w.substring(1))
    .join(" ")
      .toLowerCase()
      .trim();
    return (
    <tr>
      <td>
        <span className="fw-normal">{index + rowNumber}</span>
      </td>
      <td>
        <span className="fw-normal">
          {format(parseISO(offer_date), "dd-MM-yyyy")}
        </span>
      </td>
      <td>
        <span className="fw-normal">{offer_number === "draft" ? translated_status.toLowerCase() : offer_number}</span>
      </td>
      <td>
        <span className="fw-normal">{customer_name}</span>
      </td>

      <td>
        <span className="fw-normal">
          <StatusBullet status={status} />
          &nbsp;&nbsp;
            {currentLang === "nl" ? translated_status :
               offerStatus === "Published" ? "Open" : status.replace(/_/g, " ")
            }
        </span>
      </td>

      <td>
        <span className="fw-normal">{numberFormatter.format(offer_lines[0]?.price / 100)}</span>
      </td>

      <td>
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle
            as={Button}
            split
            variant="link"
            drop="down"
            className="text-dark m-0 p-0"
            id="dropdown-split-basic"
          >
            <span className="icon icon-sm">
              <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="user-dropdown">
            {offerStatus !== "draft" && (
              <>
                <Dropdown.Item as={Link} to={`/view-offer/${id}`}>
                  <FontAwesomeIcon icon={faEye} className="me-2" />
                  {t("View Offer")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/offer-details/${uuid}`}>
                  <FontAwesomeIcon icon={faEye} className="me-2" />
                  {t("View Offer for Customer")}
                </Dropdown.Item>
              </>
            )}
            {offerStatus === "draft" && (
              <>
                <Dropdown.Item as={Link} to={`/edit-offer/${id}`}>
                  <FontAwesomeIcon icon={faEdit} className="me-2" />
                  {t("edit")}
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => {
                    if (
                      window.confirm(
                        t("Are you sure you wish to delete this offer?")
                      )
                    )
                      deleteOffer(id, paginationData?.page || 1);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
                  {t("remove")}
                </Dropdown.Item>
              </>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
}
